module.exports = __webpack_public_path__ + "img/ad_en2.20f058e4.png";